module.exports = __webpack_public_path__ + "static/media/27.f35576bd.webp";